<script>
    export let color
</script>

<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="2.16125" y="0.102539" width="25" height="2.5" transform="rotate(45 2.16125 0.102539)" fill={color} />
    <rect x="0.161133" y="18.1025" width="25" height="2.5" transform="rotate(-45 0.161133 18.1025)" fill={color} />
</svg>
    